import BaseDB from 'libs/DB/BaseDB'

/**
 * BaseDB가 wrap한 record를 직접 타입으로 정의 (jmapDownloadCache 패턴).
 * data: 보고 완료 사실만 단순 페이로드로 보관.
 */
export interface ReadReceiptReportCacheRecord {
  receipt_id: string
  data: {
    /** 저장될 때는 항상 true (false 상태는 캐시하지 않음 — 다음 진입에 GET state로 재확인). */
    already_reported: true
    /** 응답의 first_reported_at (ISO). */
    reported_at?: string
  }
  expireTime?: number | null
  isExpired?: () => boolean
}

/**
 * 수신확인 보고(report) 캐시 — 수신자 본인이 명시적 read 보고를 이미 보냈는지 빠르게 판단.
 * `already_reported === true` 가 확인된 receipt만 저장. 한 번 캐시된 receipt는 다음 진입부터
 * GET state / POST read 둘 다 호출 안 함.
 *
 * 저장 조건 (응답에서 already_reported === true 일 때만):
 *   - GET /api/read/{id}/state 응답
 *   - POST /api/read/{id} 응답 (드물지만 동시성 케이스)
 *
 * 본 디바이스가 첫 보고자 (POST 응답에서 already_reported === false) 인 경우는 캐시하지 않는다.
 * 다음 진입 때 GET state 로 서버 진실을 한 번 더 확인 후 true 면 그제야 캐시.
 *
 * 사용:
 *   addData(receiptId, { already_reported: true, reported_at })
 *   getData(receiptId).data.already_reported
 */
const readReceiptReportCacheDB = new BaseDB<ReadReceiptReportCacheRecord>(
  'readReceiptReportCacheDB',
  {
    version: 1,
    key: 'receipt_id',
    expireDuration: 30 * 24 * 60 * 60 * 1000, // 30일
    skipPreload: true,
  },
)

export default readReceiptReportCacheDB
